import { Tab } from '@headlessui/react'
import { propOr } from 'ramda'

import useProgram from '../stores/use-program'

const programSelector = propOr({}, 'program')

const Description = () => {
  const program = useProgram(programSelector)
  const createMarkup = () => {
    return { __html: `${program.description}` }
  }
  return (
    <>
      <Tab.Panel className='pt-10'>
        <div
          className='custom-font program-desc'
          dangerouslySetInnerHTML={createMarkup()}
        />
      </Tab.Panel>
      <style jsx>{`
        .custom-font {
          font-size: calc(16px + (30 - 16) * (100vw - 375px) / (1920 - 375));
          font-weight: 300;
        }
      `}</style>
    </>
  )
}

export default Description
